var map = {
	"./cargo_ship_side.svg": 5078,
	"./commercial_fishing_boat_side.svg": 8293,
	"./high_speed_craft_side.svg": 4450,
	"./law_enforcement_boat_side.svg": 8277,
	"./military_ship_side.svg": 6329,
	"./other_side.svg": 7561,
	"./passenger_ship_side.svg": 3936,
	"./pilot_boat_side.svg": 6070,
	"./pleasure_craft_side.svg": 4682,
	"./sailboat_side.svg": 2764,
	"./search_and_rescue_boat_side.svg": 6131,
	"./tanker_ship_side.svg": 3748,
	"./towing_ship_side.svg": 9498,
	"./tug_side.svg": 2160,
	"./unknown_side.svg": 3599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6637;